import { render, staticRenderFns } from "./ConsultReportPrint.vue?vue&type=template&id=a4dc5252&"
import script from "./ConsultReportPrint.vue?vue&type=script&lang=ts&"
export * from "./ConsultReportPrint.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultReportPrint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports